import LicencePaymentModal from './licence-payment-modal';

interface SummaryDetailsFormProps {
    accommodationServices: Array<{
        baseFee: number;
        calculationDays: number;
        calculationFormula: string | null;
        id: number;
        managementFee: number;
        name: string;
        percentageRate: number;
    }>;
    selectedServices: Array<{ id: string; label: string }>;
    businessName: string;
    physicalLocation: string;
    tin: string;
    facilityDetails: {
        conferenceRooms: boolean;
        parking: boolean;
        restaurant: boolean;
        swimmingPool: boolean;
    };
    baseFee: number;
    managementFee: number;
    inspectionFee: string;
    totalFees: number;
    showPaymentForm: boolean;
    setShowPaymentForm: React.Dispatch<React.SetStateAction<boolean>>;
    handleModalSubmit: () => void;
}

export default function SummaryLicenceDetailsForm({
    businessName,
    physicalLocation,
    tin,
    selectedServices,
    baseFee,
    managementFee,
    inspectionFee,
    totalFees,
    showPaymentForm,
    setShowPaymentForm,
    handleModalSubmit
}: SummaryDetailsFormProps) {
    return (
        <div className="w-full">
            <h1 className="text-lg font-bold mb-2">Summary</h1>
            <p className="text-xs mb-4 text-gray-600">Review and confirm all provided details before submitting.</p>
            <hr className="mb-4" />

            <div className="mb-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <span className="text-xs text-gray-500">License Category</span>
                        <p className="text-sm font-semibold capitalize">{businessName}</p>
                    </div>
                    <div>
                        <span className="text-xs text-gray-500">Physical Location</span>
                        <p className="text-sm font-semibold capitalize">{physicalLocation}</p>
                    </div>
                    <div>
                        <span className="text-xs text-gray-500">Total Rooms</span>
                        <p className="text-sm font-semibold capitalize">{tin}</p>
                    </div>
                </div>
            </div>

            <hr className="mb-4" />
            <div className="mb-4">
                <h2 className="text-sm font-semibold mb-2">Accommodation Category</h2>
                <div className="grid grid-cols-3 gap-4">
                    <ul className="text-sm font-semibold list-disc pl-4">
                        {selectedServices?.map((service, index) => (
                            <li key={index} className="capitalize text-xs">{service.label}</li>
                        ))}
                    </ul>
                </div>
            </div>

            <hr className="mb-4" />

            <div className="mb-4 mt-2">
                <h2 className="text-sm font-semibold mb-2">Fee Calculation</h2>
                <div className="space-y-2 text-gray-700 text-sm">
                    <div className="flex justify-between">
                        <span>Base Fee</span>
                        <span>{baseFee} TZS</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Management Fee</span>
                        <span>{managementFee} TZS</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Inspection Fee</span>
                        <span>{inspectionFee ?? 0} TZS</span>
                    </div>
                    <div className="border-t border-gray-300 pt-2 flex justify-between font-semibold text-gray-900">
                        <span>Total Fees</span>
                        <span>{totalFees} TZS</span>
                    </div>
                </div>
            </div>

            <div className="">
                <div>
                    <input
                        type="checkbox"
                        className="mr-2"
                        // required
                    />
                    <span className="text-sm text-gray-500">I agree to the terms and conditions</span>
                </div>
                <div>
                    <p className="font-light text-sm text-left mt-1">
                        I hereby declare that all the information provided in this application is accurate, complete, and truthful to the best of my knowledge. I understand that any false or misleading information may result in the rejection of my application or the revocation of approval at any stage.
                    </p>
                    <p className="mt-3 font-light text-sm text-left">
                        I accept full responsibility for the validity of the information submitted and agree to comply with all applicable regulations and requirements set forth by the Zanzibar Commission for Tourism (ZCT).
                    </p>
                </div>
            </div>



            <>
                <LicencePaymentModal
                    baseFee={baseFee}
                    managementFee={managementFee}
                    inspectionFee={inspectionFee}
                    totalFees={totalFees}
                    isOpen={showPaymentForm}
                    onClose={() => setShowPaymentForm(false)}
                    onSubmit={handleModalSubmit}
                />

            </>
        </div>
    );
}
